<template>
  <el-container class="add-dialog renewal-add-dialog">
    <header>
      <span>续费</span>
      <i class="iconfont icon-close" @click="dialogClose"></i>
    </header>
    <div class="content">
      <div class="banner">
        <div class="h1">续费</div>
        <div class="h2">感谢客户又一次信任我们</div>
      </div>
      <div class="form">
        <div class="form-header">基本信息</div>
        <div class="form-content">
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>客户名称</span>
            <div class="item-right">
              <el-select v-model="companyName" placeholder="请选择(必填)" filterable :filter-method="remoteMethod" @change="queryRenewalOrderTimeList">
                <el-option v-for="item in userList" :key="item.id" :label="item.company_name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_cn"><i class="el-icon-warning"></i>{{err_cn}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>客户姓名</span>
            <div class="item-right">
              <el-input v-model="userName" placeholder="请输入内容" size="medium" readonly></el-input>
            </div>
            <div class="err" v-if="err_un"><i class="el-icon-warning"></i>{{err_un}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>联系电话</span>
            <div class="item-right">
              <el-input v-model="phone" placeholder="请输入(必填)" size="medium" readonly></el-input>
            </div>
            <div class="err" v-if="err_p"><i class="el-icon-warning"></i>{{err_p}}</div>
          </div>
          <div class="form-item">
            <span class="item-title item-title2"><span><span class="need">*</span>套餐</span><span>开始日期</span></span>
            <div class="item-right">
              <el-date-picker v-model="startDate" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker>
            </div>
            <div class="err" v-if="err_sd"><i class="el-icon-warning"></i>{{err_sd}}</div>
          </div>
          <div class="form-item">
            <span class="item-title item-title2"><span><span class="need">*</span>套餐</span><span>结束日期</span></span>
            <div class="item-right">
              <el-date-picker v-model="endDate" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker>
            </div>
            <div class="err" v-if="err_ed"><i class="el-icon-warning"></i>{{err_ed}}</div>
          </div>
          <div class="form-item single">
            <span class="item-title">备注</span>
            <div class="item-right">
              <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSave">保 存</el-button>
    </footer>
  </el-container>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import tool from '@/common/js/tool.js'
export default {
  props: ['renewal'],
  data () {
    return {
      response: this.renewal,
      addType: '',
      companyName: '',
      userName: '',
      phone: '',
      startDate: new Date().getTime(),
      endDate: new Date().getFullYear(),
      remark: '',
      err_cn: '',
      err_un: '',
      err_p: '',
      err_sd: '',
      err_ed: '',
      userList: [],
      orderTimeList: []
    }
  },
  mounted () {
    let date = new Date()
    this.startDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime()
    this.endDate = new Date((date.getFullYear() + 1) + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59').getTime()
    this.userList = []
    console.log('renewal', this.renewal)
    // if (this.renewal.account_id) {
    HTTPServer.queryFormalUserList({'pageNum': 1, 'pageSize': 999, 'keyWord': this.renewal.company_name}, 'Loading').then((res) => {
      this.userList = res.dataList
      this.userList.map((item) => {
        if (item.id === this.renewal.account_id) {
          this.companyName = item.id
          this.userName = item.user_name
          this.phone = item.phone
          this.remark = this.renewal.remark
          if (this.renewal.start_time) {
            this.startDate = this.renewal.start_time
            this.endDate = this.renewal.end_time
          } else {
            this.queryRenewalOrderTimeList()
          }
        }
      })
    })
    // }
  },
  methods: {
    dialogSave () {
      var b = this.dataTraversal()
      if (b) {
        var jsondata = {'account_id': this.companyName, 'user_name': this.userName, 'phone': this.phone, 'remark': this.remark, 'start_time': this.startDate, 'end_time': this.endDate}
        jsondata.end_time = (new Date((new Date(this.endDate)).toLocaleDateString())).getTime() + 24 * 60 * 60 * 1000 - 1
        // console.log(tool.formatDate(jsondata.start_time, 'yyyy-MM-dd HH:mm:ss'), tool.formatDate(jsondata.end_time, 'yyyy-MM-dd HH:mm:ss'))
        if (this.renewal.id) {
          console.log(tool.formatDate(this.renewal.start_time, 'yyyy-MM-dd'), tool.formatDate(this.renewal.end_time, 'yyyy-MM-dd'))
          let content = []
          if (this.renewal.start_time !== jsondata.start_time) {
            content.push('套餐开始时间从' + tool.formatDate(this.renewal.start_time, 'yyyy-MM-dd') + '修改为' + tool.formatDate(jsondata.start_time, 'yyyy-MM-dd'))
          }
          if (this.renewal.end_time !== jsondata.end_time) {
            content.push('套餐结束时间从' + tool.formatDate(this.renewal.end_time, 'yyyy-MM-dd') + '修改为' + tool.formatDate(jsondata.end_time, 'yyyy-MM-dd'))
          }
          if (this.renewal.remark !== jsondata.remark) {
            content.push('备注从' + this.renewal.remark + '修改为' + jsondata.remark)
          }
          jsondata.operatorRecord = content.join('；')
          jsondata.id = this.renewal.id
          HTTPServer.editRenewal(jsondata, 'Loading').then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success'
            })
            this.$bus.emit('closeAddModal', true)
            this.$bus.emit('query-renewal-list', true)
          })
        } else {
          jsondata.operatorRecord = '为客户进行了续费“' + tool.formatDate(this.startDate, 'yyyy-MM-dd') + ' - ' + tool.formatDate(this.endDate, 'yyyy-MM-dd') + ' ”'
          HTTPServer.saveRenewal(jsondata, 'Loading').then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success'
            })
            this.$bus.emit('closeAddModal', true)
            this.$bus.emit('query-renewal-list', true)
          })
        }
        console.log(jsondata)
      }
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_cn = ''
      this.err_un = ''
      this.err_p = ''
      this.err_v = ''
      this.err_pn = ''
      this.err_sd = ''
      this.err_ed = ''
      this.err_a = ''
      this.err_ds = ''
      if (!this.companyName) {
        this.err_cn = '公司名称不能为空'
        return false
      }
      if (!this.userName) {
        this.err_un = '客户姓名不能为空'
        return false
      }
      if (!this.phone) {
        this.err_p = '联系电话不能为空'
        return false
      }
      if (!this.startDate) {
        this.err_sd = '套餐开始日期不能为空'
        return false
      }
      if (!this.endDate) {
        this.err_ed = '套餐结束日期不能为空'
        return false
      }
      if (this.startDate > this.endDate) {
        this.err_ed = '套餐结束日期不能小于或等于开始时间'
        return false
      }
      let overlap = this.orderTimeList.find(v => {
        return !(this.startDate < v.start_time && this.endDate < v.start_time) && !(this.startDate > v.end_time && this.endDate > v.end_time)
      })
      if (overlap && this.orderTimeList.length > 0) {
        this.err_sd = '续费时间存在重叠，请重新确定时间时间'
        return false
      }
      return true
    },
    /** 关闭弹窗 */
    dialogClose () {
      this.$bus.emit('closeAddModal', true)
    },
    /** 客户搜索   */
    remoteMethod (tag, tag1, tag2) {
      if (!tag) {
        this.companyName = undefined
        this.userList = []
      } else {
        HTTPServer.queryFormalUserList({'pageNum': 1, 'pageSize': 99, 'keyWord': tag}, 'Loading').then((res) => {
          this.userList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
      }
    },
    /** 客户选择 */
    companyChange () {
      HTTPServer.queryRenewalListByFormalUser({'pageNum': 1, 'pageSize': 1, 'user_id': this.companyName}, 'Loading').then((res) => {
        let contains = tool.contains(this.userList, 'id', this.companyName)
        let date = new Date()
        if (contains) {
          this.userName = contains.user_name
          this.phone = contains.phone
          date = new Date(contains.end_time)
        }
        let dataList = res.dataList
        if (dataList.length > 0) {
          date = new Date(dataList[0].end_time)
        }
        this.startDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime()
        this.endDate = new Date((date.getFullYear() + 1) + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59').getTime()
      })
    },
    // 获取客户续费套餐时间
    queryRenewalOrderTimeList () {
      this.companyChange()
      HTTPServer.queryRenewalOrderTimeList({'accountId': this.companyName}, 'Loading').then((res) => {
        console.log(111, res)
        this.orderTimeList = res
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/renewal-add.vue